var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import _ from 'lodash';
import React from 'react';
import { getIconSettledProps } from '../utils';
import './style.less';
var loopRender = function (key, props, supportColor, svgProps, colorList, levelColors) {
    if (levelColors === void 0) { levelColors = []; }
    var isRootNode = props.isRootNode, name = props.name, _a = props.attributes, attributes = _a === void 0 ? {} : _a, children = props.children;
    var compProps = (function () {
        if (isRootNode) {
            return __assign(__assign({ key: key }, attributes), svgProps);
        }
        if (!attributes.fill || !supportColor) {
            return __assign({ key: key }, attributes);
        }
        var fill = attributes.fill;
        var colorLevel;
        if (!_.includes(levelColors, fill)) {
            levelColors.push(fill);
            colorLevel = levelColors.length - 1;
        }
        else {
            colorLevel = _.indexOf(levelColors, fill);
        }
        var colorFill = _.get(colorList, colorLevel, '').replace(' ', '') || fill;
        return __assign(__assign({ key: key }, attributes), { fill: colorFill });
    })();
    return React.createElement(name, compProps, _.isEmpty(children) ? undefined : _.map(children, function (child, index) {
        return loopRender(key + "-" + name + "-" + index, child, supportColor, {}, colorList, levelColors);
    }));
};
var IconBase = React.forwardRef(function (props, ref) {
    var _a = props.svgJson, svgJson = _a === void 0 ? {} : _a, color = props.color, restProps = __rest(props, ["svgJson", "color"]);
    var _b = svgJson, icon = _b.icon, name = _b.name;
    var _c = getIconSettledProps(__assign(__assign({}, restProps), { name: name })), spanProps = _c.spanProps, svgProps = _c.svgProps;
    var supportColor = name.startsWith('multiTone-') || name.startsWith('filled-');
    var colorList = _.split(color, ',');
    return (React.createElement("span", __assign({}, spanProps, { ref: ref }), loopRender("svg-" + name, icon, supportColor, svgProps, colorList)));
});
IconBase.displayName = 'IconBase';
export default IconBase;
